import { render, staticRenderFns } from "./ManuelContent.vue?vue&type=template&id=01fa6417&scoped=true"
import script from "./ManuelContent.vue?vue&type=script&lang=js"
export * from "./ManuelContent.vue?vue&type=script&lang=js"
import style0 from "./ManuelContent.vue?vue&type=style&index=0&id=01fa6417&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fa6417",
  null
  
)

export default component.exports